import { render, staticRenderFns } from "./StarvationSpeciesWaiver.vue?vue&type=template&id=62d49fbd&scoped=true&"
import script from "./StarvationSpeciesWaiver.vue?vue&type=script&lang=js&"
export * from "./StarvationSpeciesWaiver.vue?vue&type=script&lang=js&"
import style0 from "./StarvationSpeciesWaiver.vue?vue&type=style&index=0&id=62d49fbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d49fbd",
  null
  
)

export default component.exports